<template>
  <main class="page">
    <section class="section page__content">
      <div class="welcome-page__inner">
        <div class="welcome-page__logo">
          <Logo />
        </div>

        <h1 class="title welcome-page__title">Добро пожаловать на портал ПромСервис</h1>

        <p class="text welcome-page__text">
          Далеко-далеко за словесными, горами в стране гласных и согласных живут рыбные тексты. Дороге необходимыми своего запятой дорогу, рот продолжил составитель языком над вскоре бросил о он, великий свой подпоясал знаках текста всемогущая?
        </p>
        <p class="text welcome-page__text">
          Далеко-далеко за словесными горами, в стране гласных и согласных живут рыбные тексты. От всех запятой силуэт даль которое свой букв, приставка рукопись использовало. Ты вскоре оксмокс языком выйти но рукописи осталось составитель маленькая?
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import Logo from '@/components/page/Logo'

export default {
  name: 'Home',
  components: { Logo },

  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .welcome-page {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - #{$header_height});

    &__inner {
      width: 100%;
      max-width: 390px;
      margin: 100px auto 0;

      @media screen and (max-width: $tablet_start) {
        margin-top: 0;
      }
    }

    &__logo {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }

    &__title {
      margin-bottom: 20px;
    }

    &__text {
      color: $font_color_second;
      margin-bottom: 20px;
    }

    &__link {
      display: inline-block;
      color: $color_second-light;
      border-bottom: 1px solid currentColor;
      line-height: 1.15;
      transition: .3s;

      &:active {
        color: $color_second-dark;
      }

      &[disabled] {
        color: $color_deactive;
        pointer-events: none;
      }
    }
  }
</style>
